<button
    qpxButton
    matButton="elevated"
    size="sm"
    [qpxTooltip]="label()"
    [attr.aria-label]="label()"
    [attr.aria-pressed]="expanded()"
    (click)="onToggleRequested()"
    class="icon-only"
>
    <ng-icon qpx size="sm" [name]="icon()" matButtonIcon />
    <span class="sr-only">{{ label() }}</span>
</button>
